/*eslint-disable */
import { resourceUsage } from "process";

function get_firstchild(n) {
  let x = n.firstChild;
  while (x.nodeType != 1) {
    x = x.nextSibling;
  }
  return x;
}
export function readjudgx(strRange) {
  let parser = new DOMParser();
  let doc = parser.parseFromString(strRange, "text/xml");
  let rsarray = [];
  let rgs = doc.getElementsByTagName("judge")[0];
  let rg = rgs.textContent.toLowerCase();
  if ("true" === rg) {
    rsarray.push({
      judgx: true
    });
  } else {
    rsarray.push({
      judgx: false
    });
  }
  return rsarray;
}
function readElement(el) {
  let rgs = el.getElementsByTagName("rangeInfo");
  let rsarray = [];
  if (rgs.length > 0) {
    let len = rgs.length;
    for (let idx = 0; idx < len; idx++) {
      let rangitem = {
        startpos: idx + 1,
        wordInfos: []
      };

      let rg = rgs[idx];
      let fsnd = get_firstchild(rg);
      let startpos = parseInt(fsnd.textContent);
      let wds = rg.getElementsByTagName("WordInfo");
      let wdlen = wds.length;
      for (let index = 0; index < wdlen; index++) {
        let wd = wds[index];
        let wdposnd = wd.getElementsByTagName("startpos")[0];
        let wdpos = parseInt(wdposnd.textContent);
        let wdcontnd = wd.getElementsByTagName("content")[0];
        let wdcontent = wdcontnd.textContent;
        let wdinfo = {
          wdType: 0,
          startpos: wdpos,
          content: wdcontent
        };
        rangitem.wordInfos.push(wdinfo);
      }
        let exps = rg.getElementsByTagName("MathExpression");
        // console.log("exps",exps)
      wdlen = exps.length;
      for (let index = 0; index < wdlen; index++) {
        let ep = exps[index];
        let epposnd = ep.getElementsByTagName("startpos")[0];
        let eppos = parseInt(epposnd.textContent);
        let eplatex = ep.getElementsByTagName("latex")[0];
        let eplatexconent = eplatex.textContent;
        let imgstartnd = ep.getElementsByTagName("imgstartpos")[0];
        let imgstartpos = parseInt(imgstartnd.textContent);
        let imgendnd = ep.getElementsByTagName("imglength")[0];
        let imglen = parseInt(imgendnd.textContent);
        let epinfo = {
          wdType: 1,
          startpos: eppos,
          imgstartpos: imgstartpos,//修改过imgpos:imgstartpos
          imglen: imglen,
          haslatex: false,
          latex: eplatexconent
        };
        rangitem.wordInfos.push(epinfo);
      }
      rangitem.wordInfos.sort((a, b) => {
        return a.startpos - b.startpos;
      });
      rsarray.push(rangitem);
    }
  }
  rsarray.sort((a, b) => {
    return a.startpos - b.startpos;
  });
  return rsarray;
}
//新增方法
function readMinElement(el) {
  let rgs = el.getElementsByTagName("rangeInfo");
  let rsarray = [];
  if (rgs.length > 0) {
    let len = rgs.length;
    for (let idx = 0; idx < len; idx++) {
      let rangitem = {
        startpos: idx + 1,
        wordInfos: []
      };

      let rg = rgs[idx];
      let fsnd = get_firstchild(rg);
      let startpos = parseInt(fsnd.textContent);
      let wds = rg.getElementsByTagName("WordInfo");
      let wdlen = wds.length;
      for (let index = 0; index < wdlen; index++) {
        let wd = wds[index];
        let wdposnd = wd.getElementsByTagName("startpos")[0];
        let wdpos = parseInt(wdposnd.textContent);
        let wdcontnd = wd.getElementsByTagName("content")[0];
        let wdcontent = wdcontnd.textContent;
        let wdinfo = {
          wdType: 0,
          startpos: wdpos,
          content: wdcontent
        };
        rangitem.wordInfos.push(wdinfo);
      }
      let exps = rg.getElementsByTagName("mathExpression"); //这里是小写
      wdlen = exps.length;
      for (let index = 0; index < wdlen; index++) {
        let ep = exps[index];
        let epposnd = ep.getElementsByTagName("startpos")[0];
        let eppos = parseInt(epposnd.textContent);
        let eplatex = ep.getElementsByTagName("latex")[0];
        let eplatexconent = eplatex.textContent;
        let imgstartnd = ep.getElementsByTagName("imgstartpos")[0];
        let imgstartpos = parseInt(imgstartnd.textContent);
        let imgendnd = ep.getElementsByTagName("imglength")[0];
        let imglen = parseInt(imgendnd.textContent);
        let epinfo = {
          wdType: 1,
          startpos: eppos,
          imgstartpos: imgstartpos,
          imglen: imglen,
          haslatex: false,
          latex: eplatexconent
        };
        rangitem.wordInfos.push(epinfo);
      }
      rangitem.wordInfos.sort((a, b) => {
        return a.startpos - b.startpos;
      });
      rsarray.push(rangitem);
    }
  }
  rsarray.sort((a, b) => {
    return a.startpos - b.startpos;
  });
  return rsarray;
}
export function readoption(strRange,data) {
  let parser = new DOMParser();
  let doc = parser.parseFromString(strRange, "text/xml");
  let rsarray = [];
  let rgs = doc.getElementsByTagName("option");
  for (let idx = 0; idx < rgs.length; idx++) {
    let ops = rgs[idx];
    let opitem = {};
    opitem.opsindex = parseInt(
      ops.getElementsByTagName("index")[0].textContent
    );
    let opscortxt = ops
      .getElementsByTagName("correct")[0]
      .textContent.toLocaleLowerCase();
    opitem.iscorrect = "true" === opscortxt;
    // console.log(ops)
    if(data===1){
      // console.log('data0',data)
      opitem.ranginfos = readMinElement(ops); 
    }else{
      // console.log('data1',data)
      opitem.ranginfos=readElement(ops)
    }
   //使用这个方法,其他的就会出现渲染失败
    rsarray.push(opitem);
  }
  return rsarray;
}

export function readRange(strRange) {
  let parser = new DOMParser();
  let doc = parser.parseFromString(strRange, "text/xml");
  return readElement(doc);
}
